define((require) => {
    "use strict";

    const ImprovedModel = require("shared/zbone/ImprovedModel");
    const Configuration = require("shared/services/Configuration");
    /**
     * An shared entity model using microservices.
     *
     * @class MsSharedEntityModel
     * @constructor
     */
    return ImprovedModel.extend("MsSharedEntityModel", {

        _api: "msExperience",

        defaults: {
            entityId: undefined,
            entityType: undefined,
            sharedWithAll: false,
            companyId: undefined,
            usersSharedWith: []
        },

        moveURL: function() {
            return `${Configuration.experienceSharedEntityBaseUrl}moveSettings`;
        },

        patchAddURL: function(entityId) {
            return `${Configuration.experienceSharedEntityBaseUrl}${this.get("entityType")}/${this.get("entityId")}/add/${entityId}`;
        },

        patchRemoveURL: function(entityId) {
            return `${Configuration.experienceSharedEntityBaseUrl}${this.get("entityType")}/${this.get("entityId")}/remove/${entityId}`;
        },

        postURL: function() {
            return `${Configuration.experienceSharedEntityBaseUrl}`;
        },

        getURL: function() {
            return `${Configuration.experienceSharedEntityBaseUrl}${this.get("entityType")}/${this.get("entityId")}/`;
        },

        fixedValues: null,

        url() {
            return this.getURL();
        },

        sharedWithAllUrl: function(sharedWithAll) {
            return `${Configuration.experienceSharedEntityBaseUrl}${this.get("entityType")}/${this.get("entityId")}/sharedWithAll/${sharedWithAll}`;
        },

        _patchSharedWithAll: function(sharedWithAll) {
            let options = {
                method: "patch"
            };
            return this._execute(options, {
                url:  this.sharedWithAllUrl(sharedWithAll),
                type: "PATCH"
            }).promise;
        },

        onChangeSharedWithAllHandler(isChecked) {
            this.set("sharedWithAll", isChecked);
            this._patchSharedWithAll(isChecked);
            return isChecked;
        },

        addSharedUser: function(id) {
            return this._execute({
                method: "patch"
            }, {
                url:  this.patchAddURL(id),
                type: "PATCH"
            });
        },

        removeSharedUser: function(entityId) {
            return this._execute({
                method: "patch"
            }, {
                url:  this.patchRemoveURL(entityId),
                type: "PATCH"
            }).promise;
        },

        moveSharedEntity: function({
            destID, destType
        }) {
            const dest = {
                id: destID,
                type: destType
            };
            const source = {
                id: this.get("entityId"),
                type: this.get("entityType")
            };

            const moveBody = {
                dest: dest,
                source: source
            };

            return this._execute({
                method: "post"
            }, {
                url:  this.moveURL(),
                type: "POST",
                data: JSON.stringify(moveBody),
                dataType: "text",
                contentType: "application/json"
            });
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/experienceOverview/experiencePermissions/MsSharedEntityModel.js